<template>
  <div class="svg-container" :style="`--width:${width || '64px'}; --height:${height || '64px'};`">
    <svg stroke="currentColor" :style="`--fillColor:${fill || '#000'};`" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
      ></path>
    </svg>
  </div>
</template>
<script type="text/javascript">
// import helper from './../helpers';

export default {
  name: "CloseButton",
  props: ["fill", "width", "height"],
  data() {
    return {};
  },
};
</script>
<style scoped>
.svg-container {
  width: var(--width);
  height: var(--height);
}

svg {
  width: 100%;
  height: auto;
}

path {
  fill: var(--fillColor);
}
</style>
